import React, { Component } from 'react'
import { Col, InputGroup, Label } from "reactstrap";
import RadioButtonField from './RadioButtonField'
import { inject, observer } from 'mobx-react';

@inject("store")
@observer
export default class RadiobuttonGroup extends Component {
    render() {
        return (
                <Col xl={this.props.xl ? this.props.xl : 'auto'} lg={this.props.lg ? this.props.lg : 'auto'} md={this.props.md ? this.props.md : 'auto'} sm={this.props.sm ? this.props.sm : 'auto'} xs={this.props.xs ? this.props.xs : 'auto'}
                className="form-input-simples">
                    {this.props.titulo ? <Label>{ this.props.titulo} { this.props.obrigatorio ? <span className="label-danger">*</span> : "" }</Label>: this.props.noTitle ? "" : <Label className="checkboxfield--no-label">empty</Label>}
                    <div className={`d-flex ${window.innerWidth < 550 && 'flex-wrap'}`}>
                        {this.props.itens.map((item, index) => {
                            return <RadioButtonField
                                    onClick={this.props.onClick}
                                    className={
                                        `${this.props.itens.length !== index + 1 && window.innerWidth > 550 ? "mr-2" : ""}
                                         ${index !== 0 && window.innerWidth < 550 ? "mt-2" : ""}`
                                        }
                                    key={index}
                                    name={this.props.name}
                                    id={item.id}
                                    label={item.label}
                                    value={item.value}
                                    checked={item.checked ? item.checked : this.props.checked}
                                    bloqueado={item.bloqueado ? item.bloqueado : this.props.bloqueado}
                            />
                        })}
                    </div>
                    { (this.props.alerta && this.props.alerta.length>0) && <Label className="label-danger">{ this.props.alerta }</Label> }
                </Col>
        )
    }
}

/**
 * { id: "", value: "", label: "", checked: true },
 * Definir uma lista de objetos contendo:
 * id, label, value do elemento
 * Definir um unico name para todos os elementos do grupo
 */


// WEBPACK FOOTER //
// ./src/modules/comum/components/RadiobuttonGroup.js